import React, { useEffect, useMemo, useRef, useState } from "react";
import useGetCommentListEndpoint from "Hooks/useGetCommentListEndpoint";
import {
  CommentJson,
  FilterComment,
} from "features/comment/types/comment.type";
import CommentModel from "common/models/CommentModel";
import { Avatar, Button, Col, List, Row, Skeleton, Typography } from "antd";
import QaItem from "./../QaItem/QaItem";
import { useAppSelector } from "app/hooks";
import { selectToken } from "features/auth/AuthSlice";
import { selectListQa } from "features/comment/CommentSlice";

type DataList = CommentJson & {
  loading?: boolean;
};

type Props = {
  item_id: string;
  item_type: string;
};
const QaList = ({ item_id, item_type }: Props) => {
  const token = useAppSelector(selectToken);
  const listQa = useAppSelector(selectListQa);
  const [list, setList] = useState<DataList[]>([]);
  const [dataWait, setDataWait] = useState<any[]>([]);
  const titleRef = useRef<HTMLElement>(null);
  const defaultFilters: FilterComment = useMemo(
    () => CommentModel.getDefaultFilter(),
    []
  );
  const [filters, setFilters] = useState<FilterComment>({
    ...defaultFilters,
    limit: 2,
    item_id: item_id,
    item_type: item_type,
  });

  const {
    listData: { currentData, data, error, isLoading },
  } = useGetCommentListEndpoint({ filters, typeList: "qa", skipload: true });

  //

  const handleScroll = () => {
    if (titleRef.current) {
      titleRef.current.scrollIntoView({
        behavior: "smooth",
        block: "center",
        inline: "start",
      });
    }
  };

  const onLoadMore = () => {
    if (data) {
      setTimeout(() => {
        setFilters((prev) => {
          return {
            ...prev,
            limit: prev.limit + 2,
          };
        });
      }, 1000);
    }

    setList(dataWait.concat([...new Array(2)].map(() => ({ loading: true }))));
  };
  // button loadmore
  const loadMore = useMemo(() => {
    if (!data || data.total <= 2) {
      return null;
    } else {
      if (list.length < data.total) {
        return (
          <Button
            style={{ margin: "8px 0", padding: "4px 0", color: "#3A393A" }}
            onClick={onLoadMore}
            type="link"
          >
            Xem thêm
          </Button>
        );
      } else {
        return (
          <Button
            style={{ margin: "8px 0", padding: "4px 0" }}
            type="link"
            onClick={() => {
              handleScroll();
              setFilters((prev) => {
                return {
                  ...prev,
                  limit: 2,
                };
              });
            }}
          >
            Thu gọn
          </Button>
        );
      }
    }

    // return data && list.length > 0 && list.length < data.total ? (
    //   list.length <= 2 ? (
    //     <Button
    //       style={{ margin: "8px 0", padding: "4px 0", color: "#3A393A" }}
    //       onClick={onLoadMore}
    //       type="link"
    //     >
    //       Xem thêm
    //     </Button>
    //   ) : (
    //     <Button
    //       style={{ margin: "8px 0", padding: "4px 0" }}
    //       type="link"
    //       onClick={() => {
    //         handleScroll();
    //         setFilters((prev) => {
    //           return {
    //             ...prev,
    //             limit: 3,
    //           };
    //         });
    //       }}
    //     >
    //       Thu gọn
    //     </Button>
    //   )
    // ) : null;
  }, [data, list]);

  //
  const hasMore: boolean = useMemo(() => {
    if (data && !error) {
      if (list.length < data.total) {
        return true;
      } else {
        return false;
      }
    } else {
      return false;
    }
  }, [data, currentData, list]);
  //

  useEffect(() => {
    if (data) {
      if (token === null) {
        setList((prev) => [...listQa].concat(data.items));
        setDataWait((prev) => [...listQa].concat(data.items));
      } else {
        setList(data.items);
        setDataWait(data.items);
      }
    }
  }, [data, listQa]);

  return (
    <div id="qaWrapper" style={{ position: "relative" }}>
      {isLoading ? (
        <>
          <Skeleton.Button
            style={{ width: 150, margin: "1.5rem 0 0 0" }}
            size="small"
            active
          ></Skeleton.Button>
          {Array.from(new Array(2)).map((i, index) => (
            <Row
              key={index}
              gutter={[
                { xs: 8, sm: 16 },
                { xs: 8, sm: 16 },
              ]}
              style={{ width: "100%", margin: "8px 0 0 0" }}
            >
              <Col span={1}>
                <Skeleton.Button
                  style={{ height: 16, marginTop: 15 }}
                  size="small"
                  active={true}
                  block={true}
                />
              </Col>
              <Col span={23}>
                <Skeleton
                  style={{ width: "100%" }}
                  paragraph={{ rows: 1 }}
                  active={true}
                />
              </Col>
            </Row>
          ))}
        </>
      ) : (
        <>
          {data && (
            <>
              {/* <Typography.Title
                style={{ fontWeight: 400, marginBottom: " 1rem 0 0.5rem 0" }}
                level={5}
                ref={titleRef}
              >
                Được hỏi nhiêu nhất
              </Typography.Title> */}
              <span style={{ visibility: "hidden" }} ref={titleRef}></span>
              <List
                loading={isLoading}
                loadMore={loadMore}
                size="small"
                bordered={false}
                dataSource={list}
                renderItem={(item) => (
                  <List.Item
                    className="qa_item_wrapper"
                    style={{
                      flexDirection: "column",
                    }}
                  >
                    <Skeleton
                      loading={item.loading ? item.loading : false}
                      paragraph={{ rows: 2 }}
                      title={false}
                      active
                    >
                      <QaItem key={item.id} data={item}></QaItem>
                    </Skeleton>
                  </List.Item>
                )}
              ></List>
            </>
          )}
        </>
      )}
    </div>
  );
};

export default QaList;
